import { render, staticRenderFns } from "./stalldetail.vue?vue&type=template&id=09badbcf&scoped=true"
import script from "./stalldetail.vue?vue&type=script&lang=js"
export * from "./stalldetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09badbcf",
  null
  
)

export default component.exports